import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7b0ad04"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'chatRight',
  props: {
  intro: String,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "chatRight",
    innerHTML: __props.intro
  }, null, 8, _hoisted_1))
}
}

})